import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".js-services-card").forEach((card) => {
	const counter = card.querySelector(".js-counter");
	const title = card.querySelector(".js-title");
	const text = card.querySelector(".js-text");

	let tl = gsap.timeline({ paused: true });

	tl.fromTo(
		[counter, title, text],
		{
			opacity: 0,
			y: "0.625rem",
		},
		{
			opacity: 1,
			y: 0,
			stagger: 0.1,
		},
		0,
	);

	ScrollTrigger.create({
		trigger: card,
		start: "top top+=50%",
		onEnter: () => {
			tl.play();
		},
		onLeaveBack: () => {
			tl.reverse();
		},
	});
});
